var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex caption font-italic"},[_c('span',[_vm._v("(")]),_c('currency-input',{ref:"currency",staticClass:"currency-input",class:{ 'white--text': _vm.white },staticStyle:{"width":"100%"},attrs:{"value":_vm.convertedValue,"currency":"USD"}}),_c('span',{staticClass:"pl-1"},[_vm._v(_vm._s(this.currencyText)+")")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }